import { getToken } from '../../utils/auth';
import { apiSlice } from '../../reducers/index';

export const plaintiffSheetsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postField: builder.mutation<any, any>({
      query: ({ factSheetId, sectionId, data }) => {
        return {
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/fields`,
          method: 'POST',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField'],
    }),
    postTable: builder.mutation<any, any>({
      query: ({ factSheetId, sectionId, data }) => {
        return {
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/tables`,
          method: 'POST',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField'],
    }),

    postTabs: builder.mutation<any, any>({
      query: ({ factSheetId, sectionId, data }) => {
        return {
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/tab-fields`,
          method: 'POST',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField'],
    }),
    deleteField: builder.mutation<any, { factSheetId: string; sectionId: string; fieldId: string }>(
      {
        query: ({ factSheetId, sectionId, fieldId }) => ({
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/fields/${fieldId}`,
          method: 'DELETE',
          headers: getToken(),
        }),
        invalidatesTags: ['updateField', 'updateSection'],
      }
    ),
    deleteTable: builder.mutation<any, { factSheetId: string; sectionId: string; tableId: string }>(
      {
        query: ({ factSheetId, sectionId, tableId }) => ({
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/tables/${tableId}`,
          method: 'DELETE',
          headers: getToken(),
        }),
        invalidatesTags: ['updateField', 'updateSection', 'updateTable'],
      }
    ),
    patchFactSheetPublish: builder.mutation<any, { id: string }>({
      query: ({ id }) => {
        return {
          url: `/fact-sheets/${id}/publish`,
          method: 'PATCH',
          headers: getToken(),
        };
      },
    }),

    updateTable: builder.mutation<any, any>({
      query: ({ data, factSheetId, sectionId, tableId }) => {
        return {
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/tables/${tableId}`,
          method: 'PUT',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField', 'updateSection'],
    }),

    updateField: builder.mutation<any, any>({
      query: ({ data, factSheetId, sectionId, fieldId }) => {
        return {
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/fields/${fieldId}`,
          method: 'PUT',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField', 'updateSection'],
    }),

    updateTabs: builder.mutation<any, any>({
      query: ({ data, factSheetId, sectionId, tabId }) => {
        return {
          url: `/fact-sheet/${factSheetId}/section/${sectionId}/tabs/${tabId}`,
          method: 'PUT',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField', 'updateSection'],
    }),

    postTabsField: builder.mutation<any, any>({
      query: ({ data, factSheetId, sectionId, tabFieldId, tabId }) => {
        return {
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/tab-fields/${tabFieldId}/tab/${tabId}/tables`,
          method: 'POST',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField', 'updateSection'],
    }),
    postTabsFields: builder.mutation<any, any>({
      query: ({ data, factSheetId, sectionId, tabFieldId, tabId }) => {
        return {
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/tab-fields/${tabFieldId}/tab/${tabId}/fields`,
          method: 'POST',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField', 'updateSection'],
    }),

    updateTabsField: builder.mutation<any, any>({
      query: ({ data, factSheetId, sectionId, tabId, fieldId }) => {
        return {
          url: `/fact-sheet/${factSheetId}/section/${sectionId}/tabs/${tabId}/fields/${fieldId}`,
          method: 'PUT',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField', 'updateSection'],
    }),

    deleteTabsField: builder.mutation<any, any>({
      query: ({ data, factSheetId, sectionId, tabFieldId, tabId, fieldId }) => {
        return {
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/tab-fields/${tabFieldId}/tab/${tabId}/fields/${fieldId}`,
          method: 'DELETE',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField', 'updateSection'],
    }),

    deleteTabsTable: builder.mutation<any, any>({
      query: ({ data, factSheetId, sectionId, tabFieldId, tabId, tableId }) => {
        return {
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/tab-fields/${tabFieldId}/tab/${tabId}/tables/${tableId}`,
          method: 'DELETE',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField', 'updateSection'],
    }),

    deleteTabs: builder.mutation<any, any>({
      query: ({ data, factSheetId, sectionId, tabFieldId }) => {
        return {
          url: `/fact-sheets/${factSheetId}/sections/${sectionId}/tab-fields/${tabFieldId}`,
          method: 'DELETE',
          headers: getToken(),
          body: data,
        };
      },
      invalidatesTags: ['updateField', 'updateSection'],
    }),
  }),
});

export const {
  usePostFieldMutation,
  useDeleteFieldMutation,
  usePatchFactSheetPublishMutation,
  useUpdateFieldMutation,
  usePostTableMutation,
  useDeleteTableMutation,
  usePostTabsMutation,
  useUpdateTabsMutation,
  usePostTabsFieldMutation,
  useUpdateTableMutation,
  usePostTabsFieldsMutation,
  useDeleteTabsFieldMutation,
  useDeleteTabsTableMutation,
  useDeleteTabsMutation,
} = plaintiffSheetsApi;
